import { ArrowDownRight, MapPin } from "lucide-react";

const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_resi-contractor/artifacts/l4co0fqy_IMG_5646.JPG";

export const Hero = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[92vh] w-full overflow-hidden grain"
    >
      {/* Background image */}
      <img
        src={HERO_IMAGE}
        alt="A Sativa Building Systems custom home under construction in Central Wisconsin at golden hour"
        className="absolute inset-0 w-full h-full object-cover"
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/70" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-10 pt-40 pb-24 sm:pt-48 sm:pb-32 min-h-[92vh] flex flex-col justify-between">
        <div className="reveal max-w-4xl">
          <div
            data-testid="hero-announce-pill"
            className="inline-flex items-center gap-2 border border-white/35 bg-white/10 backdrop-blur-md px-4 py-2 text-[11px] tracking-[0.22em] uppercase text-white font-semibold"
          >
            <span className="w-1.5 h-1.5 bg-[#C9B07A] rounded-full animate-pulse" />
            Now Offering — Construction Services
          </div>

          <h1
            data-testid="hero-headline"
            className="font-display font-bold text-white mt-8 text-[44px] sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight"
          >
            Residential
            <br />
            General Contracting,
            <span className="block text-[#C9B07A] italic font-light">built the right way.</span>
          </h1>

          <p
            data-testid="hero-subhead"
            className="font-body text-white/85 mt-7 max-w-2xl text-[15px] sm:text-lg leading-relaxed"
          >
            Sativa Building Systems is bringing two decades of sustainable building
            craft to homeowners across Central Wisconsin. High-quality, safe, and
            superior construction practices — paired with healthier materials —
            from the team behind the patented Z Panel.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <button
              type="button"
              data-testid="hero-primary-cta"
              onClick={() => scrollTo("contact")}
              className="group inline-flex items-center justify-center gap-2 bg-[#F4F3EF] text-[#1A1D1A] hover:bg-white transition-colors duration-300 px-7 py-4 text-[13px] font-semibold tracking-wide"
            >
              Start Your Project
              <ArrowDownRight
                size={18}
                className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:translate-y-0.5"
              />
            </button>
            <button
              type="button"
              data-testid="hero-secondary-cta"
              onClick={() => scrollTo("services")}
              className="inline-flex items-center justify-center gap-2 border border-white/50 text-white hover:bg-white hover:text-[#1A1D1A] transition-colors duration-300 px-7 py-4 text-[13px] font-semibold tracking-wide"
            >
              Explore Services
            </button>
          </div>
        </div>

        {/* Bottom rail */}
        <div className="reveal mt-16 sm:mt-0 grid grid-cols-2 sm:grid-cols-4 gap-6 sm:gap-10 border-t border-white/20 pt-8">
          <Stat label="Serving" value="Central Wisconsin" icon={<MapPin size={14} />} />
          <Stat label="Specialty" value="High-Quality Builds" />
          <Stat label="Materials" value="Safe & Non-Toxic" />
          <Stat label="Standards" value="Superior Craft" />
        </div>
      </div>
    </section>
  );
};

const Stat = ({ label, value, icon }) => (
  <div data-testid={`hero-stat-${label.toLowerCase().replace(/\s+/g, "-")}`} className="text-white">
    <div className="flex items-center gap-2 text-[10px] tracking-[0.25em] uppercase text-white/65 font-semibold">
      {icon}
      {label}
    </div>
    <div className="font-display font-medium text-[15px] sm:text-base mt-2">{value}</div>
  </div>
);
